export default {
  main: '#1E1E1E',
  secondary: '#ce0f69',
  contrastingColor: '#ffffff',
  priceColor: '#ce0f69',
  entryBackground: '#1E1E1E',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
